import React, { useMemo } from 'react';
import { Marks } from '../types';
import { useDotsStyles } from './styles';
import Dot from './Dot';

export interface DotsProps {
	vertical: boolean;
	size: number;
	marks?: Marks;
	dots: boolean;
	step: number;
	lowerBound: number;
	upperBound: number;
	min: number;
	max: number;
}

export default function Dots({
	vertical,
	size,
	marks,
	dots,
	step,
	lowerBound,
	upperBound,
	max,
	min,
}: DotsProps) {
	const range = max - min;
	const points = useMemo(() => {
		const pts = marks ?
			Object.keys(marks).map(parseFloat).sort((a, b) => a - b) :
			[];
		if (dots) {
			for (let i = min; i <= max; i += step) {
				if (!pts.includes(i)) {
					pts.push(i);
				}
			}
		}
		return pts;
	}, [marks, dots, step, min, max]);
	const styles = useDotsStyles([vertical, size]);

	return (
		<div className={styles.dots}>
			{points.map(point => (
				<Dot
					key={point}
					className={styles.dot}
					vertical={vertical}
					active={point <= upperBound && point >= lowerBound}
					point={point}
					range={range}
					min={min}
				/>
			))}
		</div>
	);
}
